import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../components/Constant";

export const fetchQuestion = createAsyncThunk(
  "questions/fetchQuestion",
  async ({ gameId, creator_id, question_number }) => {
    const response = await axios.post(
      `${API_URL}/kriss_kross_question_details_by_question`,
      {
        gameId,
        creator_id,
        question_number,
      },
    );

    console.log(response.data);
    return response.data;
  },
);

const questionSlice = createSlice({
  name: "questions",
  initialState: {
    currentQuestion: null, // or {} when loaded
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestion.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchQuestion.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.currentQuestion = action.payload;
      })
      .addCase(fetchQuestion.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default questionSlice.reducer;
